import type { SiteImage } from '@/types/content'

export const IMAGES = {
    'illustration-home-grey': {
        src: '/images/acm/na.webp',
        alt: "A grey-sided craftsman home with a covered porch, black-framed windows and a wood front door",
        label: 'illustration',
        width: 1600,
        height: 900
    },
    'illustration-home-white': {
        src: '/images/acm/hero.webp',
        alt: "A white two-story farmhouse with black exterior windows and a front porch",
        label: 'illustration',
        width: 900,
        height: 507
    },
    'illustration-home-brick': {
        src: '/images/acm/home2.webp',
        alt: "A painted brick and blue-sided home with black exterior windows and a wood front door",
        label: 'illustration',
        width: 1000,
        height: 1333
    },
    'illustration-window': {
        src: '/images/acm/window.webp',
        alt: "A large black-framed exterior window set into light blue lap siding",
        label: 'illustration',
        width: 900,
        height: 1200
    },
    'illustration-door': {
        src: '/images/acm/door.webp',
        alt: "A wood-look front entry door with a tall glass sidelight on a covered porch",
        label: 'illustration',
        width: 900,
        height: 1200
    },
    'illustration-detail': {
        src: '/images/acm/detail.webp',
        alt: "Dark grey lap siding meeting a black exterior window and a wood entry door",
        label: 'illustration',
        width: 1200,
        height: 800
    },
    'illustration-installer': {
        src: '/images/acm/cta.webp',
        alt: "An installer checking a new exterior window with a level",
        label: 'illustration',
        width: 700,
        height: 525
    },
    'hero-windows-doors': {
        src: '/images/acm/hero-windows-doors.webp',
        alt: "A two-story grey-sided home with new black exterior windows and a wood front entry door with glass sidelites",
        label: 'illustration'
    },
    'hero-window-replacement': {
        src: '/images/acm/hero-window-replacement.webp',
        alt: "A brick ranch home with a row of new black-framed exterior replacement windows and fresh white trim",
        label: 'illustration'
    },
    'hero-door-installation': {
        src: '/images/acm/hero-door-installation.webp',
        alt: "A covered front porch with a newly installed navy blue fiberglass entry door and glass sidelite",
        label: 'illustration'
    },
    'hero-siding': {
        src: '/images/acm/hero-siding.webp',
        alt: "A two-story home with new sage green lap siding and white board-and-batten gable accents",
        label: 'illustration'
    },
    'hero-roofing': {
        src: '/images/acm/hero-roofing.webp',
        alt: "A two-story home with a new charcoal architectural shingle roof and ridge vents",
        label: 'illustration'
    },
    'hero-pressure-washing': {
        src: '/images/acm/hero-pressure-washing.webp',
        alt: "A freshly cleaned concrete driveway and walkway leading to a white-sided home",
        label: 'illustration'
    },
    'hero-about': {
        src: '/images/acm/hero-about.webp',
        alt: "A red brick family home with a glowing porch light at early evening in a quiet Madison neighbourhood",
        label: 'illustration'
    },
    'job-porch-windows': {
        src: '/images/acm/p-porch.webp',
        alt: "Before and after: old porch windows with failing frames replaced by a new white picture window and sliders",
        label: 'job',
        caption: "Porch window replacement",
        width: 600,
        height: 800
    },
    'job-window-update': {
        src: '/images/acm/p-upd.webp',
        alt: "Before and after: a worn double-hung window in red brick replaced with a new white double-hung window",
        label: 'job',
        caption: "Double-hung window replacement in brick",
        width: 600,
        height: 800
    },
    'job-window-install': {
        src: '/images/acm/p-inst.webp',
        alt: "An ACM team member giving a thumbs up beside a newly installed picture window on a brick ranch home",
        label: 'job',
        caption: "New picture window on a brick ranch",
        width: 600,
        height: 800
    },
    'job-house-wash': {
        src: '/images/acm/p-ext.webp',
        alt: "Before and after: grey vinyl siding streaked with mildew, then clean after a soft wash",
        label: 'job',
        caption: "Soft wash on vinyl siding",
        width: 600,
        height: 800
    },
    'job-walkway': {
        src: '/images/acm/p-walk.webp',
        alt: "Before and after: a stained concrete walkway outside an apartment building, then clean",
        label: 'job',
        caption: "Walkway cleaning",
        width: 600,
        height: 800
    },
    'job-driveway': {
        src: '/images/acm/p-drive.webp',
        alt: "A freshly cleaned street apron in front of a brick home, with ACM written in the cleaned concrete",
        label: 'job',
        caption: "Driveway and curb cleaning",
        width: 600,
        height: 800
    },
    'job-walkway-before': {
        src: '/images/acm/before.webp',
        alt: "A concrete walkway covered in dirt, mulch and stains before cleaning",
        label: 'job',
        caption: "Walkway before cleaning",
        width: 596,
        height: 720
    },
    'job-walkway-after': {
        src: '/images/acm/after.webp',
        alt: "The same concrete walkway after pressure washing",
        label: 'job',
        caption: "Walkway after cleaning",
        width: 596,
        height: 720
    }
} satisfies Record<string, SiteImage>

export type ImageKey = keyof typeof IMAGES

export const getImage = (key: string): SiteImage => {
    return (IMAGES as Record<string, SiteImage>)[key] ?? IMAGES['illustration-home-grey']
}
